import { AddNewCategory } from "components/ChartOfAccounts/AddNewCategory";
import { HeaderActions } from "components/AppLayout/HeaderActions";
import DashboardContainer from "components/dashboard/DashboardContainer";
import { Button } from "components/DesignSystem/Button/Button";
import { LockedButton } from "components/DesignSystem/Button/LockedButton";
import { Header } from "components/DesignSystem/Header/Header";
import { ChatTeardropDots } from "components/icons/ChatTeardropDots";
import { WRITE_PERMISSION_KEYS } from "constants/permissions";
import { useModal } from "hooks/useModal";
import { LockedUi } from "components/LockedUi/LockedUi";
import {
  COATable,
  ExportCOA,
} from "../../../components/ChartOfAccounts/COATable";

const COAActions = ({
  commentPane,
}: {
  commentPane: { toggle: () => void };
}) => {
  return (
    <div className="t-flex t-gap-1 t-items-center">
      <ExportCOA />
      <LockedUi
        feature={WRITE_PERMISSION_KEYS.ACCOUNTING}
        blockedUi={
          <LockedButton text="Add" customType="primary" size="xsmall" />
        }
      >
        <AddNewCategory />
      </LockedUi>
      <Button customType="icon" onClick={commentPane.toggle} size="small">
        <ChatTeardropDots />
      </Button>
    </div>
  );
};

export const ChartOfAccounts = ({
  isStandalone = true,
}: {
  isStandalone?: boolean;
}) => {
  const commentPane = useModal();

  if (!isStandalone) {
    return (
      <div className="t-flex t-flex-col t-h-full">
        <HeaderActions>
          <COAActions commentPane={commentPane} />
        </HeaderActions>
        <div className="t-flex-1 t-overflow-hidden">
          <COATable commentPane={commentPane} withoutTopPadding />
        </div>
      </div>
    );
  }

  return (
    <DashboardContainer className="t-h-full sm:t-h-auto sm:t-overflow-x-visible">
      <DashboardContainer.Header className="t-px-10 sm:t-px-3">
        <Header
          v2
          title="Chart of Accounts"
          right={
            <div className="t-flex t-gap-1 t-mt-1">
              <ExportCOA />
              <LockedUi
                feature={WRITE_PERMISSION_KEYS.ACCOUNTING}
                blockedUi={
                  <LockedButton text="Add" customType="primary" size="xsmall" />
                }
              >
                <AddNewCategory />
              </LockedUi>
              <Button
                customType="icon"
                onClick={commentPane.toggle}
                size="xsmall"
              >
                <ChatTeardropDots />
              </Button>
            </div>
          }
        />
      </DashboardContainer.Header>

      <DashboardContainer.Content className="sm:t-overflow-visible">
        <div className="t-h-full t-w-full">
          <COATable commentPane={commentPane} />
        </div>
      </DashboardContainer.Content>
    </DashboardContainer>
  );
};
